import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NyquistLanding from "./components/NyquistLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NyquistLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;